const itemData = [
  {
    img: "/images/diary/oct/oct8.jpg",
    title: "Bed",
  },
  {
    img: "/images/diary/oct/oct09.jpg",
    title: "Books",
  },
  {
    img: "/images/diary/oct/oct10.jpg",
    title: "Sink",
  },
  {
    img: "/images/diary/oct/oct11.jpg",
    title: "Kitchen",
  },
  {
    img: "/images/diary/oct/oct12.jpg",
    title: "Blinds",
  },
  {
    img: "/images/diary/oct/oct13.jpg",
    title: "Chairs",
  },
  {
    img: "/images/diary/oct/oct14.jpg",
    title: "Laptop",
  },
  {
    img: "/images/diary/oct/oct15.jpg",
    title: "Doors",
  },
  {
    img: "/images/diary/oct/oct16.jpg",
    title: "Coffee",
  },
  {
    img: "/images/diary/oct/oct17.jpg",
    title: "Storage",
  },
  {
    img: "/images/diary/oct/oct18.jpg",
    title: "Candle",
  },
  {
    img: "/images/diary/oct/oct19.jpg",
    title: "Coffee table",
  },
  {
    img: "/images/gallery/1.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/2.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/3.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/4.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/5.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/6.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/7.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/8.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/9.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/10.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/11.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/12.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/13.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/14.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/15.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/16.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/17.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/18.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/19.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/20.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/21.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/22.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/23.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/24.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/25.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/26.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/27.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/28.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/29.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/30.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/31.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/32.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/33.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/34.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/35.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/36.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/37.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/38.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/39.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/40.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/41.jpg",
    title: "H&M",
  },

  {
    img: "/images/gallery/42.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/43.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/44.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/45.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/46.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/47.jpg",
    title: "H&M",
  },
  {
    img: "/images/gallery/48.jpg",
    title: "H&M",
  },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },

  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },

  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
  // {
  //   img: "/images/gallery/26.jpg",
  //   title: "H&M",
  // },
];
export default itemData;
